import {Project} from "../../models/project";
import {AppAction} from "../../root/AppAction";
import ProjectEvents from "../events/ExProjectEvents";

// 定義
export interface ExProjectStore {
    projectList: Project[];
    isLoading: boolean;
    errorMessage: string;
}

// 初期値
const initialStore:
ExProjectStore = {
    projectList: [],
    isLoading: false,
    errorMessage: ""
};

// 実行
export default function projectList(state: ExProjectStore = initialStore, action: AppAction) {
    switch (action.type) {
        // プロジェクト一覧取得
        case ProjectEvents.GetAllProjectListStarted:
            return {
                ...state,
                isLoading: true
           };
        case ProjectEvents.GetAllProjectListComplete:
            return {
                ...state,
                projectList: action.projectList,
                isLoading: false,
                errorMessage: ""
           };
        // フィルター
        case ProjectEvents.filterProjectListStart:
            return {
                ...state,
                isLoading: true
           };
        case ProjectEvents.filterProjectListComplete:
            return {
                ...state,
                projectList: action.filterResult,
                isLoading: false
           };
        // プロジェクト更新
        case ProjectEvents.UpdateProjectStarted:
            return {
                ...state
           };
        case ProjectEvents.UpdateProjectComplete:
            console.log(action)
            return {
                ...state,
                errorMessage: "",
                projectList: action.projectList,
           };
        case ProjectEvents.UpdateProjectFailed:
            return {
                ...state,
                errorMessage: action.error
           };
        // プロジェクトにビデオ（エビソード・関連）を追加
        case ProjectEvents.AddVideoToProject:
            return {
                ...state
           };
        case ProjectEvents.AddVideoToProjectComplete:
            return {
                ...state,
                projectList: state.projectList.map(el => {
                    return el.id === action.project.id
                        ? action.project
                        : el;
               })
           };

        default:
            return state;
   }
}
